module.exports = __webpack_public_path__ + "static/img/wallet@3x.6091bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/wallet@3x.png
// module id = 5cul
// module chunks = 0